import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import { API_URL } from '../config/api';

const BACKEND_URL = API_URL;
const API = `${BACKEND_URL}/api`;

const DeletePortefeuilleDialog = ({ open, onClose, portefeuille, onSuccess }) => {
  const [deleteOperations, setDeleteOperations] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await axios.delete(
        `${API}/portefeuilles/${portefeuille.id}?delete_operations=${deleteOperations}`,
        { withCredentials: true }
      );
      toast.success('Portefeuille supprimée !');
      onSuccess();
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDeleteOperations(false);
    onClose();
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-700">
            <AlertTriangle className="h-5 w-5" />
            Supprimer la portefeuille
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4">
            <div className="font-semibold text-red-900 mb-2">{portefeuille.nom}</div>
            <div className="text-sm text-red-700">
              Solde : <span className="font-bold">{formatCurrency(portefeuille.solde)}</span>
            </div>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-3">
            <div className="flex items-start gap-3">
              <Checkbox
                id="delete_operations"
                checked={deleteOperations}
                onCheckedChange={setDeleteOperations}
              />
              <div className="flex-1">
                <Label htmlFor="delete_operations" className="text-sm font-medium cursor-pointer">
                  Supprimer aussi les opérations du calendrier
                </Label>
                <p className="text-xs text-gray-600 mt-1">
                  Si coché : supprime tous les dépôts liés<br />
                  Si non coché : garde les opérations pour cohérence budgétaire
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-2 pt-2">
            <Button type="button" variant="outline" onClick={handleClose} className="flex-1" disabled={loading}>
              Annuler
            </Button>
            <Button onClick={handleSubmit} className="flex-1 bg-red-600" disabled={loading}>
              {loading ? 'Suppression...' : 'Supprimer'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeletePortefeuilleDialog;